import React from 'react';
import { NavLink } from 'react-router-dom';
import LineIcon from 'react-lineicons';
import { menuHover, blackOrWhite } from '../../../../Infrastructure/ManipulateColors';

const LearnerNav = props => {
    return (
        <>
            <li data-toggle="collapse" href="#learnerDropdown" role="button" style={{ "--hover-color": menuHover(props.context.primaryNavColour) }}>
                <div className="chev">
                    <LineIcon name="chevron-right" style={{ color: props.context.sidebarIconColour }} />
                </div>
                <NavLink to="#" activeClassName='sidebar-active'>
                    <LineIcon name="users" style={{ color: props.context.sidebarIconColour }} />
                    <span className="item" style={{ color: props.context.primaryNavColour ? blackOrWhite(props.context.primaryNavColour) : "black" }}>Learners</span>
                </NavLink>
            </li>

            <div className="collapse" id="learnerDropdown">
                <div className="sidebar-submenu">
                    <ol style={{ "backgroundColor": props.manipulateColours(props.context.primaryNavColour) }}>
                        <li style={{ "--sub-menu-hover-color": menuHover(props.manipulateColours(props.context.primaryNavColour)), "--ol-color": blackOrWhite(props.context.primaryNavColour) }}><NavLink activeClassName='sidebar-active' to="/learner-progress"><span>Learner Progress</span></NavLink></li>
                        <li style={{ "--sub-menu-hover-color": menuHover(props.manipulateColours(props.context.primaryNavColour)), "--ol-color": blackOrWhite(props.context.primaryNavColour) }}><NavLink activeClassName='sidebar-active' to="/manage-learners"><span>Manage Learners</span></NavLink></li>
                    </ol>
                </div>
            </div>
        </>
    );
};

export default LearnerNav;